import queryString from 'query-string'

const useQueryString = <T = unknown>(): [T] => {
  return [queryString.parse(window.location.search) as unknown as T]
}

export default useQueryString
